'use client'

import React from 'react'

import { PrivacyPolicyPage } from 'Components/Pages'

export default function PrivacyPolicy() {
  return <PrivacyPolicyPage />
}
